<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2020-2023 (original work) Open Assessment Technologies SA ;

    /**
     * Component displays step progress in a form of counter.
     * @property {Number} position 1-indexed position in the test
     * @property {Number} total stats.total from testPart
     */

    export let position;
    export let total;
</script>


{#if position && total}
    <div class="counter">{position} / {total}</div>
{/if}
